var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-container" },
    [
      _c(
        "BjDrawerForm",
        {
          ref: "BjDrawerForm",
          attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
          on: { handleConfirm: _vm.handleConfirm },
        },
        [
          _c(
            "BjDivider",
            {
              scopedSlots: _vm._u([
                {
                  key: "right",
                  fn: function () {
                    return [
                      _vm.isEdit
                        ? _c("BjLogButton", {
                            attrs: {
                              id: _vm.form.id,
                              permission: "BusinessChannelOnlineList_Log",
                              title: _vm.form.name,
                              api: "channelApi",
                            },
                          })
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [_vm._v(_vm._s(_vm.$t("ChannelManagement.new.title")) + " ")]
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelManagement.new.name"),
                        prop: "name",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("BjFormItemCode", {
                    attrs: {
                      readonly: _vm.isEdit,
                      label: _vm.$t("ChannelManagement.new.code"),
                      prop: "code",
                    },
                    model: {
                      value: _vm.form.code,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "code", $$v)
                      },
                      expression: "form.code",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelManagement.new.Channel"),
                        prop: "channelTypeCode",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: { "lov-code": "SCHL.CHANNEL_TYPE" },
                        model: {
                          value: _vm.form.channelTypeCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "channelTypeCode", $$v)
                          },
                          expression: "form.channelTypeCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelManagement.new.Type"),
                        prop: "onlineStoreTypeCode",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: { "lov-code": "SCHL.SHOP_TYPE" },
                        model: {
                          value: _vm.form.onlineStoreTypeCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "onlineStoreTypeCode", $$v)
                          },
                          expression: "form.onlineStoreTypeCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelManagement.new.charge"),
                        prop: "manager",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.manager,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "manager", $$v)
                          },
                          expression: "form.manager",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelManagement.new.company"),
                        prop: "salesOrganizingId",
                      },
                    },
                    [
                      _c("BjCompanyTreeSelect", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.form.salesOrganizingId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "salesOrganizingId", $$v)
                          },
                          expression: "form.salesOrganizingId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelManagement.new.Invoice"),
                        prop: "invoiceTypeCode",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: { "lov-code": "SCHL.INVOICE_TYPE" },
                        model: {
                          value: _vm.form.invoiceTypeCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "invoiceTypeCode", $$v)
                          },
                          expression: "form.invoiceTypeCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelManagement.new.Associated"),
                        prop: "relationPhysicalShopId",
                      },
                    },
                    [
                      _c("BjSelectStorePhysical", {
                        attrs: {
                          "default-params": {
                            status: true,
                            selfPickupFlag: true,
                          },
                        },
                        model: {
                          value: _vm.form.relationPhysicalShopId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "relationPhysicalShopId", $$v)
                          },
                          expression: "form.relationPhysicalShopId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelManagement.new.describe"),
                        prop: "description",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          type: "textarea",
                          autosize: "",
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "description", $$v)
                          },
                          expression: "form.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelManagement.Header.taxCode"),
                        prop: "taxCode",
                      },
                    },
                    [
                      _c("BjInputCode", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.taxCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "taxCode", $$v)
                          },
                          expression: "form.taxCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelManagement.Header.accountCode"),
                        prop: "accountCode",
                      },
                    },
                    [
                      _c("BjInputCode", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.accountCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "accountCode", $$v)
                          },
                          expression: "form.accountCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelManagement.Header.currency"),
                        prop: "currency",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: { "option-list": _vm.CURRENCY_LIST },
                        model: {
                          value: _vm.form.currency,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "currency", $$v)
                          },
                          expression: "form.currency",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelManagement.Header.project"),
                        prop: "project",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.project,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "project", $$v)
                          },
                          expression: "form.project",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelManagement.Header.typeOfFreight"),
                        prop: "autoTableStatus",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: { "lov-code": "FREIGHT_TYPE" },
                        model: {
                          value: _vm.form.autoTableStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "autoTableStatus", $$v)
                          },
                          expression: "form.autoTableStatus",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t(
                      "ChannelManagement.Header.shippingCostAutoStatus"
                    ),
                  },
                },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.form.shippingCostAutoStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "shippingCostAutoStatus", $$v)
                      },
                      expression: "form.shippingCostAutoStatus",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("BjDivider", [
            _vm._v(
              _vm._s(_vm.$t("ChannelManagement.new.relateWarehouse")) + " "
            ),
          ]),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("ChannelManagement.new.warehouse"),
                    prop: "channelWarehouseId",
                  },
                },
                [
                  _c("BjSelectWarehouse", {
                    ref: "RefBjSelectWarehouse",
                    attrs: { "type-code": ["channel"], clearable: "" },
                    on: {
                      change: function (v, item) {
                        _vm.form.channelWarehouseName = item.name
                      },
                    },
                    model: {
                      value: _vm.form.channelWarehouseId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "channelWarehouseId", $$v)
                      },
                      expression: "form.channelWarehouseId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("BjDivider", [
            _vm._v(_vm._s(_vm.$t("ChannelManagement.new.Store"))),
          ]),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("el-checkbox", {
                attrs: {
                  checked: !_vm.isEdit,
                  label: _vm.$t("enableText"),
                  disabled: "",
                },
                model: {
                  value: _vm.form.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "status", $$v)
                  },
                  expression: "form.status",
                },
              }),
              _c("br"),
              _c("el-checkbox", {
                attrs: {
                  checked: !_vm.isEdit,
                  label: _vm.$t("ChannelManagement.new.products"),
                },
                model: {
                  value: _vm.form.autoDownloadGoods,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "autoDownloadGoods", $$v)
                  },
                  expression: "form.autoDownloadGoods",
                },
              }),
              _c("br"),
              _c("el-checkbox", {
                attrs: { label: _vm.$t("ChannelManagement.new.orders") },
                model: {
                  value: _vm.form.autoPullOrder,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "autoPullOrder", $$v)
                  },
                  expression: "form.autoPullOrder",
                },
              }),
              _c(
                "div",
                { staticStyle: { height: "40px", "line-height": "40px" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          _vm.form.syncSafeValue = _vm.syncSafeValue
                        },
                      },
                      model: {
                        value: _vm.form.autoSyncInventory,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "autoSyncInventory", $$v)
                        },
                        expression: "form.autoSyncInventory",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("ChannelManagement.new.inventory")) +
                          " "
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.autoSyncInventory,
                              expression: "form.autoSyncInventory",
                            },
                          ],
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                color: "#606266",
                                padding: "0 10px",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("ChannelManagement.new.security")
                                  )
                              ),
                            ]
                          ),
                          _c("el-input-number", {
                            staticStyle: { width: "80px" },
                            attrs: {
                              min: 0,
                              precision: 0,
                              controls: false,
                              label: _vm.$t("ChannelManagement.new.security"),
                            },
                            model: {
                              value: _vm.form.syncSafeValue,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "syncSafeValue", $$v)
                              },
                              expression: "form.syncSafeValue",
                            },
                          }),
                          _c("br"),
                          _c(
                            "el-link",
                            {
                              staticStyle: {
                                cursor: "auto",
                                "margin-left": "10px",
                              },
                              attrs: { type: "danger", underline: false },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("ChannelManagement.new.Note"))
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }